<template>
    <div class="header-scroll">
        <b-container fluid>
            <b-row class="header">
                <b-col cols="8" class="header--logo-wrapper text-left">
                    <a href="#">
                      <img v-if="site === 'gentech'" src="/images/gentech_logo.png" width="160" alt="Gentech">
                      <img v-if="site === 'nativfilter'" src="/images/nativ_logo.png" width="180" alt="Nativfilter">
                    </a>
                  <h3>
                    <span v-if="site === 'gentech'">The best filtering solution for our technical generation</span>
                    <span v-if="site === 'nativfilter'">Maximum Access. Maximum Protection.</span>
                  </h3>
                    <template  v-if="show_admin_button">
                        <b-col cols="2">
                            <button class="button-primary" @click.prevent="back_to_admin" variant="info">Back to Admin</button>
                        </b-col>

                    </template>
                </b-col>
                <b-col cols="4" class="header--dropdown-wrapper d-flex justify-content-end">
                    <div class="left-side-trigger--menu" @click="changeSidebar">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>

                    <div class="d-flex">
                        <router-link :to="{ name: 'profile' }">
                            <div class="user-img">
                                <div class="user-initials">{{ user_name()}}</div>
                            </div>
                        </router-link>
                        <div class="user-name-and-status d-flex">
                            <div class="user-name">
                                <p>
                                    <router-link :to="{ name: 'profile' }"> {{user.name}} </router-link>
                                </p>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex justify-content-between notifications-menu--wrapper">
                    </div>
                    <a href="#" @click.prevent="logout" class="d-flex align-items-center"><span class="log-out"><svg aria-hidden="true" data-prefix="fas" data-icon="sign-out-alt" class="svg-inline--fa fa-sign-out-alt" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="30"><path fill="currentColor" d="M497 273L329 441c-15 15-41 4.5-41-17v-96H152c-13.3 0-24-10.7-24-24v-96c0-13.3 10.7-24 24-24h136V88c0-21.4 25.9-32 41-17l168 168c9.3 9.4 9.3 24.6 0 34zM192 436v-40c0-6.6-5.4-12-12-12H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h84c6.6 0 12-5.4 12-12V76c0-6.6-5.4-12-12-12H96c-53 0-96 43-96 96v192c0 53 43 96 96 96h84c6.6 0 12-5.4 12-12z"/></svg></span></a>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import LocaleDropdown from './LocaleDropdown'
    import Cookies from 'js-cookie'

    export default {
        layout: 'default',
        middleware: 'user',

        components: {
            LocaleDropdown
        },

        data: () => ({
            appName: window.config.appName,
            show_admin_button: false,
          site: window.config.getSite,
        }),

        computed: mapGetters({
            user: 'auth/user'
        }),

        mounted()
        {
            this.$store.dispatch('auth/fetchUser');

            if (Cookies.get('admin_id') != undefined)
            {
                this.show_admin_button = true;
            }
        },

        methods: {
            changeSidebar(){
                this.$store.dispatch('layout/changeSidebarStatus');
            },

            async logout () {

                // Log out the user.
                await this.$store.dispatch('auth/logout');

                // Redirect to login.

                this.$router.push({name: 'login'});
            },

            async back_to_admin()
            {
                //getting the user token based on user id
                const { data } = await axios.post('/api/admin/log-in-as-user', {id : Cookies.get('admin_id')});

                // Save the token.
                this.$store.dispatch('auth/saveToken', {
                    token: data.token,
                    remember: true
                })

                // Fetch the user.
                await this.$store.dispatch('auth/fetchUser');

                this.$router.push({ name: 'users' });
            },

            user_name()
            {
                let username = this.user.name.trim().split(/\s+/);

                if (username.length == 1)
                {
                    return this.user.name.charAt(0).toUpperCase();
                }

                if (username.length >= 2)
                {
                    return username[0].charAt(0).toUpperCase() + username[1].charAt(0).toUpperCase();
                }

            }
        },

        // computed: {
        //     user: function () {
        //         return this.$store.state.auth.user;
        //     },
        // }
    }
</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/components/Header.vue